import * as React from "react";
const SvgMove20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 .086 13.914 4 12.5 5.414l-1.5-1.5V9h5.086l-1.5-1.5L16 6.086 19.914 10 16 13.914 14.586 12.5l1.5-1.5H11v5.086l1.5-1.5L13.914 16 10 19.914 6.086 16 7.5 14.586l1.5 1.5V11H3.914l1.5 1.5L4 13.914.086 10 4 6.086 5.414 7.5 3.914 9H9V3.914l-1.5 1.5L6.086 4 10 .086Z",
      clipRule: "evenodd"
    })
  );
export default SvgMove20Px;
